"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _destinationUrlService = require("./services/destinationUrlService");

var _utils = require("./utils");

var _CustomDomainSetupPanels = _interopRequireDefault(require("./CustomDomainSetupPanels"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DestinationUrlEdit = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DestinationUrlEdit, _Component);

  var _super = _createSuper(DestinationUrlEdit);

  function DestinationUrlEdit() {
    var _this;

    (0, _classCallCheck2.default)(this, DestinationUrlEdit);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      customURL: '',
      isLoading: true,
      error: null,
      customDomainData: null,
      isFirstPanelCompleted: false,
      hasApiFailure: false,
      isPolling: false,
      reqHash: null,
      isRetryLoading: false,
      showSuccessAlert: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "polling", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchCustomDomain", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var options,
          _options$completeFirs,
          completeFirstPanel,
          response,
          data,
          resourceRecord,
          shouldPollForResourceRecord,
          shouldPollForRequestHash,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _options$completeFirs = options.completeFirstPanel, completeFirstPanel = _options$completeFirs === void 0 ? true : _options$completeFirs;
              _context.prev = 2;
              _context.next = 5;
              return (0, _destinationUrlService.getCustomDomain)();

            case 5:
              response = _context.sent;

              if (!(response !== null && response !== void 0 && response.success && response !== null && response !== void 0 && response.data)) {
                _context.next = 13;
                break;
              }

              data = response.data;

              _this.setState(function (prevState) {
                var _getDomainName;

                // Only update customDomainData if:
                // 1. We don't have a reqHash (no POST was made yet), OR
                // 2. We have a reqHash AND it matches the RequestHash from API
                var shouldUpdateData = !prevState.reqHash || prevState.reqHash && data.RequestHash === prevState.reqHash;
                return {
                  customDomainData: shouldUpdateData ? data : prevState.customDomainData,
                  error: null,
                  // Only set customURL from API if we don't already have a user-entered value
                  customURL: prevState.customURL || ((_getDomainName = (0, _utils.getDomainName)(data)) !== null && _getDomainName !== void 0 ? _getDomainName : ''),
                  isFirstPanelCompleted: completeFirstPanel,
                  hasApiFailure: false,
                  isLoading: false
                };
              }); // Start polling if needed (when IN_PROGRESS and no ResourceRecord.Value)
              // Also start polling if we have a reqHash but no matching RequestHash in response


              if (data.IntegrationStatus === 'IN_PROGRESS') {
                resourceRecord = (0, _utils.getResourceRecord)(data);
                shouldPollForResourceRecord = !(resourceRecord !== null && resourceRecord !== void 0 && resourceRecord.Value);
                shouldPollForRequestHash = _this.state.reqHash && data.RequestHash !== _this.state.reqHash;

                if (shouldPollForResourceRecord || shouldPollForRequestHash) {
                  _this.setState({
                    isPolling: true
                  });

                  _this.startPollingForDomainValidation();
                }
              } else if (_this.state.reqHash && data.RequestHash !== _this.state.reqHash) {
                _this.setState({
                  isPolling: true
                });

                _this.startPollingForDomainValidation();
              }

              return _context.abrupt("return", true);

            case 13:
              _this.handleApiFailure();

              return _context.abrupt("return", false);

            case 15:
              _context.next = 22;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](2);
              (0, _utils.logError)('fetchCustomDomain', _context.t0);

              _this.handleApiFailure();

              return _context.abrupt("return", false);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 17]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleApiFailure", function () {
      _this.setState({
        error: null,
        customDomainData: null,
        customURL: '',
        isFirstPanelCompleted: false,
        hasApiFailure: true,
        isPolling: false,
        isLoading: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCustomURLChange", function (e) {
      _this.setState({
        customURL: e.target.value,
        error: null
      }, function () {});
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetDomainState", function () {
      var _this$polling;

      (_this$polling = _this.polling) === null || _this$polling === void 0 ? void 0 : _this$polling.stop();
      _this.polling = null;

      _this.setState({
        isLoading: true,
        error: null,
        customDomainData: null,
        isFirstPanelCompleted: false,
        hasApiFailure: false,
        isPolling: false // Keep reqHash - don't reset to null, it will be updated with new value on POST

      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSuccessfulSubmission", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var getSuccess;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.fetchCustomDomain({
                completeFirstPanel: false
              });

            case 2:
              getSuccess = _context2.sent;

              if (getSuccess) {
                _this.setState({
                  isLoading: false,
                  isFirstPanelCompleted: true,
                  hasApiFailure: false
                });
              } else {
                _this.setState({
                  isLoading: false,
                  isFirstPanelCompleted: false,
                  hasApiFailure: true,
                  error: 'Failed to update domain. Please check your domain again'
                });
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFailedSubmission", function (response, error) {
      var _response$message;

      var errorMessage = error ? (0, _utils.handleApiError)(error, _utils.ERROR_MESSAGES.VALIDATION_FAILED) : (_response$message = response.message) !== null && _response$message !== void 0 ? _response$message : _utils.ERROR_MESSAGES.VALIDATION_FAILED;

      _this.setState({
        error: errorMessage,
        isLoading: false,
        isFirstPanelCompleted: false,
        hasApiFailure: true,
        customDomainData: null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCheckAndContinue", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var customURL, validationError, _yield$submitCustomDo, response, reqHash;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              customURL = _this.state.customURL; // Validate input

              validationError = (0, _utils.validateCustomUrl)(customURL);

              if (!validationError) {
                _context4.next = 5;
                break;
              }

              _this.setState({
                error: validationError
              });

              return _context4.abrupt("return");

            case 5:
              // Reset state for new submission
              _this.resetDomainState();

              _context4.prev = 6;
              _context4.next = 9;
              return (0, _destinationUrlService.submitCustomDomain)(customURL);

            case 9:
              _yield$submitCustomDo = _context4.sent;
              response = _yield$submitCustomDo.response;
              reqHash = _yield$submitCustomDo.reqHash;

              if (response !== null && response !== void 0 && response.success) {
                // Store the request hash for polling validation
                _this.setState({
                  reqHash: reqHash
                }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                  return _regenerator.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this.handleSuccessfulSubmission();

                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
              } else {
                _this.handleFailedSubmission(response);
              }

              _context4.next = 19;
              break;

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](6);
              (0, _utils.logError)('handleCheckAndContinue', _context4.t0);

              _this.handleFailedSubmission(null, _context4.t0);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 15]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopyIntegrationCode", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var _getResourceRecord$Va, _getResourceRecord;

      var customDomainData, valueOnly;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              customDomainData = _this.state.customDomainData; // Copy only the ResourceRecord.Value as requested

              valueOnly = (_getResourceRecord$Va = (_getResourceRecord = (0, _utils.getResourceRecord)(customDomainData)) === null || _getResourceRecord === void 0 ? void 0 : _getResourceRecord.Value) !== null && _getResourceRecord$Va !== void 0 ? _getResourceRecord$Va : null;

              if (!valueOnly) {
                _context5.next = 11;
                break;
              }

              _context5.prev = 3;
              _context5.next = 6;
              return (0, _utils.copyToClipboard)(valueOnly);

            case 6:
              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](3);
              (0, _utils.logError)('handleCopyIntegrationCode', _context5.t0);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRetryConnection", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var currentFirstPanelStatus, success;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              currentFirstPanelStatus = _this.state.isFirstPanelCompleted;

              _this.setState({
                isRetryLoading: true
              });

              _context6.prev = 2;
              _context6.next = 5;
              return _this.fetchCustomDomain({
                completeFirstPanel: currentFirstPanelStatus
              });

            case 5:
              success = _context6.sent;

              if (success) {
                _this.setState({
                  isRetryLoading: false,
                  showSuccessAlert: true
                }); // Hide alert after 5 seconds


                setTimeout(function () {
                  _this.setState({
                    showSuccessAlert: false
                  });
                }, 3000);
              } else {
                _this.setState({
                  isRetryLoading: false
                });
              }

              _context6.next = 13;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](2);
              (0, _utils.logError)('handleRetryConnection', _context6.t0);

              _this.setState({
                isRetryLoading: false
              });

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startPollingForDomainValidation", function () {
      var _this$polling2;

      if ((_this$polling2 = _this.polling) !== null && _this$polling2 !== void 0 && _this$polling2.isRunning()) return;
      _this.polling = (0, _utils.createDomainStatusPoller)({
        fetchStatus: function () {
          var _fetchStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return (0, _destinationUrlService.getCustomDomain)();

                  case 2:
                    return _context7.abrupt("return", _context7.sent);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function fetchStatus() {
            return _fetchStatus.apply(this, arguments);
          }

          return fetchStatus;
        }(),
        shouldStop: function shouldStop(resp) {
          var apiData = resp === null || resp === void 0 ? void 0 : resp.data;
          var resourceRecord = (0, _utils.getResourceRecord)(apiData);
          var validationStatus = (0, _utils.getValidationStatus)(apiData);
          var currentReqHash = _this.state.reqHash;
          var requestHashMatches = !currentReqHash || (apiData === null || apiData === void 0 ? void 0 : apiData.RequestHash) === currentReqHash; // Stop polling if:
          // 1. We have ResourceRecord.Value AND RequestHash matches (or no reqHash to check)
          // 2. Validation failed AND RequestHash matches (don't stop on failed validation if hash doesn't match)
          // 3. If we don't have reqHash (no POST was made), use original logic

          if (!currentReqHash) {
            return (resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Value) != null || validationStatus === 'FAILED';
          } // Only stop when RequestHash matches AND (ResourceRecord exists OR validation failed)


          return requestHashMatches && ((resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Value) != null || validationStatus === 'FAILED');
        },
        onData: function onData(resp) {
          var apiData = resp === null || resp === void 0 ? void 0 : resp.data;
          var resourceRecord = (0, _utils.getResourceRecord)(apiData);
          var validationStatus = (0, _utils.getValidationStatus)(apiData);

          _this.setState(function (prevState) {
            var requestHashMatches = !prevState.reqHash || (apiData === null || apiData === void 0 ? void 0 : apiData.RequestHash) === prevState.reqHash; // Only update customDomainData if RequestHash matches (or no reqHash exists)

            var shouldUpdateData = requestHashMatches; // Determine if we should stop polling

            var shouldStopPolling = false;

            if (prevState.reqHash) {
              // If we have a reqHash, stop when we have resource record value AND hash matches, OR validation failed AND hash matches
              shouldStopPolling = requestHashMatches && ((resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Value) != null || validationStatus === 'FAILED');
            } else {
              // If no reqHash, use original logic
              shouldStopPolling = (resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Value) != null || validationStatus === 'FAILED';
            }

            return {
              customDomainData: shouldUpdateData ? apiData !== null && apiData !== void 0 ? apiData : null : prevState.customDomainData,
              // Only stop polling state when we're sure we should stop
              isPolling: !shouldStopPolling
            };
          });
        },
        onError: function onError() {// keep polling on transient errors
        },
        intervalMs: 5000
      });

      _this.polling.start();
    });
    return _this;
  }

  (0, _createClass2.default)(DestinationUrlEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchCustomDomain();
    }
    /**
     * Common logic for determining panel status based on prerequisites
     */

  }, {
    key: "getPanelStatusBase",
    value: function getPanelStatusBase() {
      var _customDomainData$Int;

      var _this$state = this.state,
          hasApiFailure = _this$state.hasApiFailure,
          isFirstPanelCompleted = _this$state.isFirstPanelCompleted,
          customDomainData = _this$state.customDomainData;
      return {
        canProceed: !hasApiFailure && isFirstPanelCompleted,
        integrationStatus: (_customDomainData$Int = customDomainData === null || customDomainData === void 0 ? void 0 : customDomainData.IntegrationStatus) !== null && _customDomainData$Int !== void 0 ? _customDomainData$Int : null,
        resourceRecord: (0, _utils.getResourceRecord)(customDomainData)
      };
    } // Helper functions to derive panel statuses from state

  }, {
    key: "getFirstPanelStatus",
    value: function getFirstPanelStatus() {
      if (this.state.isLoading) return 'PENDING';
      if (this.state.hasApiFailure) return null;
      return this.state.isFirstPanelCompleted ? 'COMPLETED' : null;
    }
  }, {
    key: "getSecondPanelStatus",
    value: function getSecondPanelStatus() {
      var _this$getPanelStatusB = this.getPanelStatusBase(),
          canProceed = _this$getPanelStatusB.canProceed,
          integrationStatus = _this$getPanelStatusB.integrationStatus,
          resourceRecord = _this$getPanelStatusB.resourceRecord;

      if (!canProceed) return null; // Check validation status first to handle a FAILED case

      var validationStatus = (0, _utils.getValidationStatus)(this.state.customDomainData);
      if (validationStatus === 'FAILED') return 'FAILED';
      if (integrationStatus === 'COMPLETED' || resourceRecord !== null && resourceRecord !== void 0 && resourceRecord.Value) return 'COMPLETED'; // If we're polling or integration is in progress, show PENDING

      if (this.state.isPolling || integrationStatus === 'IN_PROGRESS') return 'PENDING'; // For FAILED integration status, show FAILED only if we don't have a resource record

      if (integrationStatus === 'FAILED') return 'FAILED'; // Default to PENDING if we have API data but no resource record yet

      if (this.state.customDomainData) return 'PENDING';
      return null;
    }
  }, {
    key: "getThirdPanelStatus",
    value: function getThirdPanelStatus() {
      var _this$getPanelStatusB2 = this.getPanelStatusBase(),
          canProceed = _this$getPanelStatusB2.canProceed,
          integrationStatus = _this$getPanelStatusB2.integrationStatus,
          resourceRecord = _this$getPanelStatusB2.resourceRecord;

      if (!canProceed) return null;
      if (integrationStatus === 'COMPLETED') return 'COMPLETED';

      if (resourceRecord !== null && resourceRecord !== void 0 && resourceRecord.Value) {
        if (integrationStatus === 'FAILED') return 'FAILED';
        return 'PENDING';
      }

      return null;
    }
  }, {
    key: "getActivePanelIndex",
    value: function getActivePanelIndex() {
      var _this$state$customDom;

      if (this.state.hasApiFailure || !this.state.isFirstPanelCompleted) return 0;
      if (this.state.isPolling) return 1;
      var integrationStatus = (_this$state$customDom = this.state.customDomainData) === null || _this$state$customDom === void 0 ? void 0 : _this$state$customDom.IntegrationStatus;
      var validationStatus = (0, _utils.getValidationStatus)(this.state.customDomainData);
      if (integrationStatus === 'COMPLETED') return 2;
      if (validationStatus === 'FAILED') return 1;
      if (integrationStatus === 'IN_PROGRESS') return 1;
      if (integrationStatus === 'FAILED') return 2;
      return 0;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$polling3;

      (_this$polling3 = this.polling) === null || _this$polling3 === void 0 ? void 0 : _this$polling3.stop();
      this.polling = null; // Reset polling state when component unmounts

      this.setState({
        isPolling: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          customURL = _this$state2.customURL,
          customDomainData = _this$state2.customDomainData;
      var inputValue = (0, _utils.getCurrentUrlValue)(customURL, customDomainData);
      return (0, _preact.h)("div", {
        className: "community-settings-page"
      }, this.state.showSuccessAlert && (0, _preact.h)(_AlertComponent.default, {
        messageType: "success",
        message: "Configuration connection refreshed",
        sticky: true,
        isVisibleFor: 3000,
        onTimeoutEnd: function onTimeoutEnd() {
          return _this2.setState({
            showSuccessAlert: false
          });
        },
        onClose: function onClose() {
          return _this2.setState({
            showSuccessAlert: false
          });
        }
      }), (0, _preact.h)(_header.default, {
        title: "Change Destination URL",
        hasBreadcrumb: true,
        breadcrumbLink: "/community/settings",
        breadcrumbText: "Back to Destination URL",
        isBeta: true,
        disableCancelButton: true,
        disableSaveButton: true,
        customButtons: [{
          title: 'Discard Changes',
          variant: 'secondary',
          action: function action() {
            window.location.href = (0, _absoluteUrlRuntime.resolveUrl)('/community/settings');
          },
          newStyle: true,
          size: 'medium'
        }]
      }), (0, _preact.h)("div", {
        className: "community-settings"
      }, (0, _preact.h)("div", {
        className: "destination-url-edit"
      }, (0, _preact.h)(_CustomDomainSetupPanels.default, {
        activePanelIndex: this.getActivePanelIndex(),
        formState: {
          inputValue: inputValue,
          error: this.state.error,
          isLoading: this.state.isLoading,
          isRetryLoading: this.state.isRetryLoading
        },
        customDomainData: this.state.customDomainData,
        panelStatuses: [this.getFirstPanelStatus(), this.getSecondPanelStatus(), this.getThirdPanelStatus()],
        handlers: {
          onCustomURLChange: this.handleCustomURLChange,
          onCheckAndContinue: this.handleCheckAndContinue,
          onCopyIntegrationCode: this.handleCopyIntegrationCode,
          onRetryConnection: this.handleRetryConnection
        }
      }))));
    }
  }]);
  return DestinationUrlEdit;
}(_preact.Component);

var _default = DestinationUrlEdit;
exports.default = _default;